import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import RolesSelection from '../../ProjectsManagement/ProjectForm/components/Employees/components/EmployeeTransfer/components/RolesSelection';

const RolesSelectionModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedPositionForRoles,
  setSelectedPositionForRoles,
  initialPosition,
  selectedFunctionalRoles,
  setSelectedFunctionalRoles,
  selectedTechnicalRoles,
  setSelectedTechnicalRoles,
  selectedOrganizationalRoles,
  setSelectedOrganizationalRoles,
  lockPosition = false
}) => {
  const handleClose = () => {
    onClose();
    setSelectedPositionForRoles(null);
    setSelectedFunctionalRoles([]);
    setSelectedTechnicalRoles([]);
    if (setSelectedOrganizationalRoles) {
      setSelectedOrganizationalRoles([]);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Assign Project Roles"
      onSubmit={onSubmit}
      submitText="Update Roles"
      width="1200px"
      submitButtonProps={{
        sx: { backgroundColor: '#2563EB', color: '#FFFFFF', '&:hover': { backgroundColor: '#1E40AF' } }
      }}
    >
      <RolesSelection
        selectedPositionForRoles={selectedPositionForRoles}
        setSelectedPositionForRoles={setSelectedPositionForRoles}
        selectedFunctionalRoles={selectedFunctionalRoles}
        setSelectedFunctionalRoles={setSelectedFunctionalRoles}
        selectedTechnicalRoles={selectedTechnicalRoles}
        setSelectedTechnicalRoles={setSelectedTechnicalRoles}
        selectedOrganizationalRoles={selectedOrganizationalRoles || []}
        setSelectedOrganizationalRoles={setSelectedOrganizationalRoles || (() => {})}
        initialPosition={initialPosition}
        lockPosition={lockPosition}
      />
    </Modal>
  );
};

RolesSelectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  selectedPositionForRoles: PropTypes.string,
  setSelectedPositionForRoles: PropTypes.func.isRequired,
  initialPosition: PropTypes.string,
  selectedFunctionalRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedFunctionalRoles: PropTypes.func.isRequired,
  selectedTechnicalRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedTechnicalRoles: PropTypes.func.isRequired,
  selectedOrganizationalRoles: PropTypes.arrayOf(PropTypes.string),
  setSelectedOrganizationalRoles: PropTypes.func,
  lockPosition: PropTypes.bool
};

RolesSelectionModal.defaultProps = {
  selectedPositionForRoles: null,
  initialPosition: null,
  selectedOrganizationalRoles: [],
  setSelectedOrganizationalRoles: null,
  lockPosition: false
};

export default RolesSelectionModal; 